module.exports = __webpack_public_path__ + "media/images/user-report-icon-f85e0ca22115abb7de4626aa8d4677d6.svg";